/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_Preview_Lock_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Preview Lock" |
*
* @param {Player_Preview_Lock_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const player_preview_lock_aria_label = /** @type {((inputs?: Player_Preview_Lock_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Preview_Lock_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Verrouillage de l'Apercu")
	if (locale === "de") return /** @type {LocalizedString} */ ("Vorschausperre")
	if (locale === "it") return /** @type {LocalizedString} */ ("Blocco anteprima")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Предварительный просмотр блокировки")
	if (locale === "es") return /** @type {LocalizedString} */ ("Bloqueo de vista previa")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("预览锁定")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プレビューロック")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पूर्वावलोकन लॉक")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Bloqueio de pré-visualização")
	return /** @type {LocalizedString} */ ("Preview Lock")
});